<template>
	<div class="feature-card" :class="{'odd-card': (idx + 2) % 2 === 0, 'even-card': (idx + 2) % 2 === 1}">
    <div class="feature-card-content">
      <div class="title-container">
        <p class="emphasis feature-number">{{idx + 1}}.</p>
        <div>
          <div class="title-wrapper">
            <p class="emphasis feature-number-responsive">{{idx + 1}}.</p>
            <h3 v-html="title"></h3>
          </div>
          <div class="description">
            <p v-html="description"></p>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
export default {
  name: 'FeatureCard',
  props: {
		idx: {
      type: Number,
      required: false,
      default: 0
		},
    title: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.feature-card {
  padding: 32px;
  border-radius: 6px;
  background-color: #fefefe;
  box-shadow: 0 0 10px 0 rgba(0,0,0,.1);
  position: absolute;
  display: flex;
  align-items: center;
}
.odd-card {
  left: 0px;
}
.even-card {
  right: 0px;
}
.description {
  margin-top: 24px;
}
.feature-number {
  margin-right: 16px;
}
.title-container {
  display: flex;
}
.feature-number-responsive {
  margin-right: 8px;
  display: none;
}
@media screen and (max-width: 896px) {
  .feature-card {
    position: static;
    box-shadow: none;
    padding-bottom: 0;
  }
  .description {
    margin-top: 16px;
  }
  .feature-number {
    display: none;
  }
  .feature-number-responsive {
    display: block;
  }
  .title-wrapper {
    display: flex;
    align-items: center;
  }
}

@media screen and (max-width: 480px) {
  .description /deep/ br {
    display: none;
  }
  .feature-card {
    padding: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/FeatureCard.vue